import React from "react";
import { Popover } from "antd";
import { FilledInfoIcon } from "../../../Icons/filledInfoIcon";
import styles from "./multipleEntry.module.css";

interface MultipleEntryProps {
    selectedItems: string[];
    title: string;
}

export const MultipleEntry = ({ selectedItems, title }: MultipleEntryProps) => (
    <div className={styles.productBadgeWrapper}>
        {`${title}: ${selectedItems.length}`}
        <Popover
            content={
                <ul className={styles.productBadgeList}>
                    {selectedItems.map((item) => (
                        <li className={styles.productBadgeText} key={item}>
                            {item}
                        </li>
                    ))}
                </ul>
            }
            title={title}
            trigger="click"
            placement="bottom"
        >
            <div className={styles.iconContainer}>
                <FilledInfoIcon />
            </div>
        </Popover>
    </div>
);
